import React from 'react';
import RegularButton from 'components/CustomButtons/Button';

export const HeadersTabs = ({ header, action, isActive }) => {
  return (
    <RegularButton
      color={ isActive ? 'info' : 'transparent' }
      size="sm"
      onClick={() => action(header)}
      tooltip={ isActive ? 'remover' : 'agregar' }
    >
      {header} 
    </RegularButton>
  )
}
